import React, { useState, useEffect } from 'react';
import { Container, Button, Form, Alert } from 'react-bootstrap';
import './ForgotPasswordModal.css';
import useToast from '../../../API/GlobalHooks/useToast';
import { useNavigate } from 'react-router-dom';
import { statusUpdate } from '../../../API/Service/shopService';
import { handleWA_text_sms, handleWA_verify_sms } from './userLoginModel';
import { genOtp } from '../../../MIS/Global';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [otpMessage, setOtpMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [smsLoading, setSmsLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [genCalcOtp, setGenCalcOtp] = useState(genOtp(4));
  const [isVerify, setIsVerify] = useState(false);
  const showToast = useToast();

  // Format timer mm:ss
  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  // Timer effect
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const validateStep = () => {
    const newErrors = {};
    if (step === 1) {
      if (!mobile) newErrors.mobile = 'Mobile number is required';
      else if (!/^\d{10}$/.test(mobile)) newErrors.mobile = 'Mobile number must be 10 digits';
    }
    if (step === 2) {
      if (!otp) newErrors.otp = 'OTP is required';
      else if (!/^\d{4}$/.test(otp)) newErrors.otp = 'OTP must be 4 digits';
      // else if(String(genCalcOtp) !== String(otp)) newErrors.otp='Invalid otp! Please try again';
    }
    if (step === 3) {
      if (!newPassword) newErrors.newPassword = 'Password is required';
      else if (newPassword.length < 4) newErrors.newPassword = 'Password must be at least 4 characters';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    
    if (validateStep()) {
      if(step === 3){
        handleSubmit();
      }
      else if(step === 2){
        handleWA_verify_sms({setIsVerify,mob:mobile,otp,setStep,showToast})
      }
      else if (step < 3) {setStep((prev) => prev + 1);}
      // else {handleSubmit();}
    }
  };

  const handleBack = () => {
    if (step > 1) setStep((prev) => prev - 1);
  };

  const handleSubmit = async () => {
    setLoading(true);
   
    let data = { mob: mobile, user_otp: otp, upaswd: newPassword };
    try {
      const resData = await statusUpdate(data);
      if (resData?.data === -1) {
        showToast(`User not exists.`, 'danger');
      } else if (resData?.data?.id > 0) {
        showToast('Password reset successfully', 'success');
        navigate('/');
      }
    } catch (error) {
      showToast('Something went wrong during registration! Please try again', 'danger');
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = async () => {    
    try {
      await handleWA_text_sms({ setSmsLoading,mobile,genCalcOtp,setTimer});
      // showToast('OTP sent successfully', 'success');
      setOtpMessage('OTP is valid for 10 minutes.');       
    } catch (err) {
      showToast('Failed to send OTP', 'danger');
    } finally {
      // setSmsLoading(false);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Form.Group controlId="mobile">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control
              type="tel"
              placeholder="Enter your mobile number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value.replace(/\D/, ''))
              }
              isInvalid={!!errors.mobile}
              maxLength={10}
              autoComplete="off"
            />
            <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
          </Form.Group>
        );
      case 2:
        return (
          <>
            <Form.Group controlId="otp">
              <Form.Label>OTP</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/, ''))}
                isInvalid={!!errors.otp}
                maxLength={4}
                autoComplete="off"
              />
              <Form.Control.Feedback type="invalid">{errors.otp}</Form.Control.Feedback>
              <div className="mt-2 d-flex justify-content-end">
                <Button
                  type="button"
                  variant="outline-primary"
                  size="sm"
                  disabled={timer > 0}
                  onClick={()=>{
                    setSmsLoading(true);
                    setTimer(120); // 2 minutes
                    handleSendOtp();
                  }}
                >
                  {timer > 0
                    ? `Resend OTP (${formatTime(timer)})`
                    : smsLoading
                    ? `Resend OTP`
                    : 'Send OTP'}
                </Button>
              </div>
              {/* {otpMessage && (
                <Alert variant="info" className="mt-2 py-1">
                  {otpMessage}
                </Alert>
              )} */}
            </Form.Group>
          </>
        );
      case 3:
        return (
          <Form.Group controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              isInvalid={!!errors.newPassword}
              autoComplete="off"
            />
            <Form.Control.Feedback type="invalid">{errors.newPassword}</Form.Control.Feedback>
          </Form.Group>
        );
      default:
        return null;
    }
  };

  return (
    <Container className="my-5" style={{ maxWidth: '500px' }}>
      
      <h3 className="text-center mb-4">Forgot Password</h3>

      {/* Stepper */}
      <div className="stepper d-flex justify-content-between mb-4">
        {['Mobile', 'OTP', 'Password'].map((label, idx) => (
          <div
            key={idx}
            className={`step-item ${step === idx + 1 ? 'active' : step > idx + 1 ? 'completed' : ''}`}
          >
            <div className="circle">{idx + 1}</div>
            <div className="label">{label}</div>
          </div>
        ))}
      </div>

      {/* Form */}
      <Form noValidate>{renderStep()}</Form>

      {/* Navigation Buttons */}
      <div className="d-flex justify-content-between mt-4">
        <Button
          variant="secondary"
          onClick={handleBack}
          disabled={step === 1 || (step === 2 && timer > 0)}
        >
          Back
        </Button>
        <Button variant="primary" onClick={handleNext}>
          
          {loading || isVerify ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {loading ? "Submitting..." : "Authenticating..."}
            </>
          ) : step === 3 ? 'Submit' : 'Next'}
        </Button>
      </div>
    </Container>
  );
};

export default ForgotPasswordPage;
